import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createBlock as _createBlock, Transition as _Transition, normalizeStyle as _normalizeStyle, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  class: "grid min-h-0 flex-1 grid-cols-1 gap-6 lg:grid-cols-12"
};
const _hoisted_2 = {
  class: "lg:col-span-3"
};
const _hoisted_3 = {
  class: "flex min-h-0 flex-col lg:col-span-9"
};
const _hoisted_4 = {
  class: "list-page-table-panel list-page-table-panel--fill"
};
const _hoisted_5 = {
  class: "filter-bar-field is-wide relative"
};
const _hoisted_6 = {
  class: "data-table-shell"
};
const _hoisted_7 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_8 = {
  class: "data-table text-sm min-w-[960px]"
};
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = {
  class: "data-table-td"
};
const _hoisted_11 = {
  class: "max-w-xs"
};
const _hoisted_12 = {
  class: "data-table-cell-title truncate"
};
const _hoisted_13 = {
  key: 0,
  class: "mt-1 flex flex-wrap gap-1"
};
const _hoisted_14 = {
  class: "data-table-td text-xs text-slate-600"
};
const _hoisted_15 = {
  class: "data-table-td text-xs text-slate-600"
};
const _hoisted_16 = {
  class: "data-table-td text-center"
};
const _hoisted_17 = {
  class: "data-table-td text-center"
};
const _hoisted_18 = {
  class: "data-table-td text-center text-xs text-slate-500"
};
const _hoisted_19 = {
  class: "data-table-td text-center"
};
const _hoisted_20 = ["onClick"];
const _hoisted_21 = {
  class: "data-table-td data-table-sticky-right data-table-sticky-action"
};
const _hoisted_22 = {
  class: "flex items-center justify-center gap-1"
};
const _hoisted_23 = ["onClick"];
const _hoisted_24 = ["onClick"];
const _hoisted_25 = ["onClick"];
const _hoisted_26 = {
  class: "relative more-menu-container"
};
const _hoisted_27 = ["onClick"];
const _hoisted_28 = {
  class: "relative bg-gradient-to-r from-primary-600 to-primary-500 px-6 py-5"
};
const _hoisted_29 = {
  class: "relative flex items-center justify-between"
};
const _hoisted_30 = {
  class: "text-lg font-semibold text-white"
};
const _hoisted_31 = {
  class: "mt-0.5 text-sm text-primary-100"
};
const _hoisted_32 = {
  class: "space-y-5 px-6 py-6"
};
const _hoisted_33 = {
  class: "space-y-1.5"
};
const _hoisted_34 = {
  class: "space-y-1.5"
};
const _hoisted_35 = {
  class: "space-y-5 px-6 py-6"
};
const _hoisted_36 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_37 = {
  class: "space-y-1.5"
};
const _hoisted_38 = {
  class: "space-y-1.5"
};
const _hoisted_39 = {
  class: "flex justify-end gap-3 border-t border-slate-100 bg-slate-50/50 px-6 py-4"
};
const _hoisted_40 = {
  class: "relative bg-gradient-to-r from-primary-600 to-primary-500 px-6 py-5"
};
const _hoisted_41 = {
  class: "relative flex items-center justify-between"
};
const _hoisted_42 = {
  class: "text-lg font-semibold text-white"
};
const _hoisted_43 = {
  class: "mt-0.5 text-sm text-primary-100"
};
const _hoisted_44 = {
  class: "overflow-y-auto max-h-[calc(90vh-180px)] px-6 py-6 space-y-5"
};
const _hoisted_45 = {
  class: "space-y-4"
};
const _hoisted_46 = {
  class: "grid grid-cols-1 gap-4 rounded-xl border border-slate-200 bg-slate-50/30 p-4 lg:grid-cols-2"
};
const _hoisted_47 = {
  class: "space-y-1.5 lg:col-span-2"
};
const _hoisted_48 = {
  class: "space-y-1.5"
};
const _hoisted_49 = {
  class: "space-y-1.5"
};
const _hoisted_50 = {
  class: "space-y-1.5"
};
const _hoisted_51 = {
  class: "space-y-1.5"
};
const _hoisted_52 = {
  class: "space-y-4"
};
const _hoisted_53 = {
  class: "grid grid-cols-2 gap-4 rounded-xl border border-slate-200 bg-slate-50/30 p-4"
};
const _hoisted_54 = {
  class: "space-y-1.5"
};
const _hoisted_55 = {
  class: "space-y-1.5"
};
const _hoisted_56 = {
  class: "space-y-4"
};
const _hoisted_57 = {
  class: "space-y-4 rounded-xl border border-slate-200 bg-slate-50/30 p-4"
};
const _hoisted_58 = {
  class: "space-y-1.5"
};
const _hoisted_59 = {
  key: 0,
  class: "space-y-1.5"
};
const _hoisted_60 = {
  class: "space-y-4"
};
const _hoisted_61 = {
  class: "rounded-xl border border-slate-200 bg-slate-50/30 p-4 space-y-4"
};
const _hoisted_62 = {
  key: 0,
  class: "space-y-2"
};
const _hoisted_63 = {
  class: "flex items-center gap-3 min-w-0"
};
const _hoisted_64 = {
  class: "min-w-0"
};
const _hoisted_65 = {
  class: "text-sm font-medium text-slate-900 truncate"
};
const _hoisted_66 = {
  class: "text-xs text-slate-500"
};
const _hoisted_67 = ["onClick"];
const _hoisted_68 = {
  class: "group flex cursor-pointer flex-col items-center justify-center rounded-xl border-2 border-dashed border-slate-300 bg-white p-6 transition-all hover:border-primary-400 hover:bg-primary-50/30"
};
const _hoisted_69 = {
  key: 1,
  class: "space-y-2"
};
const _hoisted_70 = {
  class: "flex items-center gap-3 min-w-0"
};
const _hoisted_71 = {
  class: "min-w-0"
};
const _hoisted_72 = {
  class: "text-sm font-medium text-slate-900 truncate"
};
const _hoisted_73 = {
  class: "text-xs text-slate-500"
};
const _hoisted_74 = ["onClick"];
const _hoisted_75 = {
  class: "relative bg-gradient-to-r from-primary-600 to-primary-500 px-6 py-5"
};
const _hoisted_76 = {
  class: "relative flex items-center justify-between"
};
const _hoisted_77 = {
  class: "overflow-y-auto max-h-[calc(90vh-100px)] px-6 py-6"
};
const _hoisted_78 = {
  key: 0,
  class: "space-y-4 animate-pulse"
};
const _hoisted_79 = {
  class: "flex flex-wrap items-center gap-2"
};
const _hoisted_80 = {
  class: "rounded-full bg-primary-100 px-2 py-0.5 text-xs font-medium text-primary-700"
};
const _hoisted_81 = {
  class: "mt-4 text-xl font-semibold text-slate-900"
};
const _hoisted_82 = {
  class: "mt-4 grid grid-cols-2 gap-3 rounded-xl border border-slate-200 bg-slate-50/50 p-4"
};
const _hoisted_83 = {
  key: 0,
  class: "flex items-center gap-2 text-sm"
};
const _hoisted_84 = {
  class: "text-slate-900"
};
const _hoisted_85 = {
  key: 1,
  class: "flex items-center gap-2 text-sm"
};
const _hoisted_86 = {
  class: "text-slate-900"
};
const _hoisted_87 = {
  key: 2,
  class: "flex items-center gap-2 text-sm"
};
const _hoisted_88 = {
  class: "text-slate-900"
};
const _hoisted_89 = {
  key: 3,
  class: "flex items-center gap-2 text-sm"
};
const _hoisted_90 = {
  class: "text-slate-900"
};
const _hoisted_91 = {
  class: "flex items-center gap-2 text-sm"
};
const _hoisted_92 = {
  class: "text-slate-900"
};
const _hoisted_93 = {
  key: 0,
  class: "mt-4 flex flex-wrap gap-1.5"
};
const _hoisted_94 = {
  class: "mt-5 space-y-3"
};
const _hoisted_95 = {
  class: "rounded-xl border border-slate-200 bg-white p-5"
};
const _hoisted_96 = {
  class: "prose prose-sm max-w-none text-slate-700"
};
const _hoisted_97 = {
  key: 1,
  class: "mt-5 space-y-3"
};
const _hoisted_98 = {
  class: "space-y-2"
};
const _hoisted_99 = {
  class: "flex items-center gap-3"
};
const _hoisted_100 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_101 = {
  class: "text-xs text-slate-500"
};
const _hoisted_102 = {
  class: "flex items-center gap-2"
};
const _hoisted_103 = ["disabled", "onClick"];
const _hoisted_104 = {
  key: 0,
  class: "flex items-center gap-1"
};
const _hoisted_105 = {
  key: 1
};
const _hoisted_106 = ["onClick"];
const _hoisted_107 = {
  class: "mt-5 flex items-center gap-4 rounded-lg bg-slate-50 px-4 py-3 text-xs text-slate-500"
};
const _hoisted_108 = {
  class: "flex items-center gap-1.5"
};
const _hoisted_109 = {
  class: "flex items-center gap-1.5"
};
const _hoisted_110 = {
  key: 2,
  class: "py-12 text-center"
};
const _hoisted_111 = {
  class: "relative bg-gradient-to-r from-primary-600 to-primary-500 px-6 py-5"
};
const _hoisted_112 = {
  class: "relative flex items-center justify-between"
};
const _hoisted_113 = {
  class: "mt-0.5 max-w-xs truncate text-sm text-primary-100"
};
const _hoisted_114 = {
  class: "space-y-5 px-6 py-6"
};
const _hoisted_115 = {
  class: "space-y-1.5"
};
const _hoisted_116 = {
  key: 0,
  class: "space-y-1.5"
};
const _hoisted_117 = {
  key: 1,
  class: "rounded-lg border border-primary-200 bg-primary-50 p-3"
};
const _hoisted_118 = {
  class: "flex justify-end gap-3 border-t border-slate-100 bg-slate-50/50 px-6 py-4"
};
const _hoisted_119 = {
  class: "relative bg-gradient-to-r from-primary-600 to-primary-500 px-6 py-5"
};
const _hoisted_120 = {
  class: "relative flex items-center justify-between"
};
const _hoisted_121 = {
  class: "px-6 py-6"
};
const _hoisted_122 = {
  key: 0,
  class: "space-y-3 animate-pulse"
};
const _hoisted_123 = {
  key: 1,
  class: "relative"
};
const _hoisted_124 = {
  class: "space-y-3"
};
const _hoisted_125 = {
  class: "text-sm font-semibold"
};
const _hoisted_126 = {
  class: "flex-1 min-w-0 pt-1"
};
const _hoisted_127 = {
  class: "flex items-center gap-2"
};
const _hoisted_128 = {
  key: 0,
  class: "shrink-0 rounded-full bg-primary-600 px-2 py-0.5 text-[10px] font-medium text-white"
};
const _hoisted_129 = {
  class: "mt-1 flex items-center gap-2 text-xs text-slate-500"
};
const _hoisted_130 = {
  key: 2,
  class: "py-10 text-center"
};
const _hoisted_131 = {
  key: 0,
  class: "fixed inset-0 z-50",
  role: "dialog",
  "aria-modal": "true"
};
const _hoisted_132 = {
  class: "absolute right-0 top-0 h-full w-full max-w-lg overflow-hidden bg-white shadow-2xl ring-1 ring-black/5"
};
const _hoisted_133 = {
  class: "flex h-full flex-col"
};
const _hoisted_134 = {
  class: "relative bg-gradient-to-r from-primary-600 to-primary-500 px-6 py-5"
};
const _hoisted_135 = {
  class: "relative flex items-center justify-between"
};
const _hoisted_136 = {
  class: "mt-0.5 max-w-xs truncate text-sm text-primary-100"
};
const _hoisted_137 = {
  class: "flex-1 overflow-y-auto px-6 py-6"
};
const _hoisted_138 = {
  key: 0,
  class: "space-y-4 animate-pulse"
};
const _hoisted_139 = {
  key: 1,
  class: "space-y-4"
};
const _hoisted_140 = {
  class: "flex items-center justify-between"
};
const _hoisted_141 = {
  class: "flex items-center gap-2"
};
const _hoisted_142 = {
  class: "rounded-full bg-primary-600 px-2.5 py-1 text-xs font-semibold text-white shadow-sm shadow-primary-600/30"
};
const _hoisted_143 = {
  key: 0,
  class: "rounded-full status-badge is-success px-2 py-0.5 text-xs font-medium"
};
const _hoisted_144 = {
  class: "flex items-center gap-1 opacity-0 transition-opacity group-hover:opacity-100"
};
const _hoisted_145 = ["onClick"];
const _hoisted_146 = ["onClick"];
const _hoisted_147 = {
  class: "mt-3 text-sm font-medium text-slate-900"
};
const _hoisted_148 = {
  key: 0,
  class: "mt-1.5 text-xs text-slate-500"
};
const _hoisted_149 = {
  key: 1,
  class: "mt-2 rounded-lg bg-slate-50 px-3 py-2 text-xs text-slate-600"
};
const _hoisted_150 = {
  class: "mt-3 flex items-center gap-3 text-xs text-slate-400"
};
const _hoisted_151 = {
  class: "flex items-center gap-1"
};
const _hoisted_152 = {
  class: "flex items-center gap-1"
};
const _hoisted_153 = {
  key: 2,
  class: "py-16 text-center"
};
const _hoisted_154 = {
  class: "relative bg-gradient-to-r from-red-600 to-red-500 px-6 py-5"
};
const _hoisted_155 = {
  class: "relative flex items-center justify-between"
};
const _hoisted_156 = {
  class: "px-6 py-6"
};
const _hoisted_157 = {
  class: "rounded-xl border border-red-100 bg-red-50/50 p-4 text-sm text-slate-700"
};
const _hoisted_158 = {
  class: "flex justify-end gap-3 border-t border-slate-100 bg-slate-50/50 px-6 py-4"
};
const _hoisted_159 = {
  class: "relative flex items-center justify-between bg-gradient-to-r from-primary-600 to-primary-500 px-6 py-3"
};
const _hoisted_160 = {
  class: "relative flex items-center gap-3 min-w-0"
};
const _hoisted_161 = {
  class: "text-sm font-medium text-white truncate"
};
const _hoisted_162 = {
  class: "flex-1 overflow-hidden bg-slate-100"
};
const _hoisted_163 = ["src"];
import { onMounted, onUnmounted, reactive, ref, computed } from 'vue';
import { ElMessage } from 'element-plus';
import KbCategoryTree from './components/KbCategoryTree.vue';
import AppPagination from '@/components/AppPagination.vue';
import DeptSelector from '@/components/DeptSelector/index.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import RichTextEditor from '@/components/RichTextEditor.vue';
import { uploadFile } from '@/api/file';
import { formatDateTimeText } from '@/utils/dateFormat';
import { useKbCategoryManagement } from './composables/useKbCategoryManagement';
import AppModal from '@/components/AppModal.vue';
import KbDetailPreviewModal from '@/components/KbDetailPreviewModal.vue';
import { getPolicyCategoryTree, createPolicyCategory, updatePolicyCategory, deletePolicyCategory, getPolicyRegulationPage, getPolicyRegulationDetail, createPolicyRegulation, updatePolicyRegulation, deletePolicyRegulation, publishPolicyRegulation, invalidatePolicyRegulation, getPolicyVersions, getPolicyVersionDetail, rollbackPolicyRegulation, sendPolicyNotify, getPolicySupersederChain, downloadPolicyAttachment, previewPolicyAttachment } from '@/api/kb';

// ==================== 分类 ====================

export default {
  __name: 'PolicyManagement',
  setup(__props) {
    const categoryState = useKbCategoryManagement({
      loadCategoryTree: getPolicyCategoryTree,
      createCategory: createPolicyCategory,
      updateCategory: updatePolicyCategory,
      defaultStatus: 1,
      messages: {
        loadError: '\u52a0\u8f7d\u5206\u7c7b\u5931\u8d25',
        emptyNameWarning: '\u8bf7\u8f93\u5165\u5206\u7c7b\u540d\u79f0',
        updateSuccess: '\u5206\u7c7b\u66f4\u65b0\u6210\u529f',
        createSuccess: '\u5206\u7c7b\u521b\u5efa\u6210\u529f',
        saveError: '\u4fdd\u5b58\u5206\u7c7b\u5931\u8d25'
      }
    });
    const categoryTree = categoryState.categoryTree;
    const categoryLoading = categoryState.categoryLoading;
    const selectedCategoryId = categoryState.selectedCategoryId;
    const showCategoryModal = categoryState.showCategoryModal;
    const isCategoryEdit = categoryState.isCategoryEdit;
    const categoryForm = categoryState.categoryForm;
    const loadCategories = categoryState.loadCategories;
    const flatCategories = categoryState.flatCategories;
    const getCategoryName = categoryState.getCategoryName;
    const handleCategorySelect = categoryState.handleCategorySelect;
    const handleAddCategory = categoryState.handleAddCategory;
    const handleAddChildCategory = categoryState.handleAddChildCategory;
    const handleEditCategory = categoryState.handleEditCategory;
    const closeCategoryModal = categoryState.closeCategoryModal;
    const submitCategory = categoryState.submitCategory;
    const dataList = ref([]);
    const listLoading = ref(false);
    const searchKeyword = ref('');
    const searchStatus = ref('');
    const searchUrgency = ref('');
    const pageSize = ref(20);
    const pageInfo = reactive({
      current: 1,
      total: 0,
      hasPrevious: false,
      hasNext: false
    });
    const loadList = async (page = 1) => {
      listLoading.value = true;
      try {
        const data = await getPolicyRegulationPage({
          page,
          size: pageSize.value,
          categoryId: selectedCategoryId.value || undefined,
          keyword: searchKeyword.value || undefined,
          status: searchStatus.value === '' ? undefined : Number(searchStatus.value),
          urgencyLevel: searchUrgency.value === '' ? undefined : Number(searchUrgency.value)
        });
        dataList.value = data.records || [];
        Object.assign(pageInfo, {
          current: data.current || 1,
          total: data.total || 0,
          hasPrevious: data.hasPrevious,
          hasNext: data.hasNext
        });
      } catch (error) {
        ElMessage.error(error.message || '加载列表失败');
      } finally {
        listLoading.value = false;
      }
    };
    const resetFilters = () => {
      searchKeyword.value = '';
      searchStatus.value = '';
      searchUrgency.value = '';
      selectedCategoryId.value = null;
      loadList(1);
    };
    const handlePageChange = page => {
      loadList(page);
    };
    const handlePageSizeChange = size => {
      pageSize.value = size;
      loadList(1);
    };
    const handleCategoryTreeSelect = id => {
      handleCategorySelect(id, () => loadList(1));
    };
    const policyStatusText = s => ({
      0: '草稿',
      1: '已发布',
      2: '已失效'
    })[s] || '未知';
    const policyStatusClass = s => ({
      0: 'status-badge is-neutral',
      1: 'status-badge is-success',
      2: 'status-badge is-danger'
    })[s] || 'status-badge is-neutral';
    const urgencyText = level => ({
      0: '普通',
      1: '重要',
      2: '紧急'
    })[level] || '普通';
    const urgencyClass = level => ({
      0: 'status-badge is-neutral',
      1: 'status-badge bg-amber-100 text-primary-700',
      2: 'status-badge is-danger'
    })[level] || 'status-badge is-neutral';

    // ==================== 表单 ====================
    const showFormModal = ref(false);
    const isEdit = ref(false);
    const formSubmitting = ref(false);
    const form = reactive({
      id: null,
      categoryId: '',
      title: '',
      content: '',
      documentNumber: '',
      issuingAuthority: '',
      effectiveDate: '',
      expireDate: '',
      urgencyLevel: 0,
      tags: '',
      changeSummary: '',
      currentVersion: null,
      // 当前版本号（乐观锁）
      files: [],
      // 新增的文件
      existingAttachments: [] // 已有的附件（保留的）
    });
    const openFormModal = async item => {
      if (item) {
        isEdit.value = true;
        try {
          const data = await getPolicyRegulationDetail(item.id);
          Object.assign(form, {
            id: data.id,
            categoryId: data.categoryId,
            title: data.title,
            content: data.content || '',
            documentNumber: data.docNumber || '',
            issuingAuthority: data.issuingAuthority || '',
            effectiveDate: data.effectiveDate || '',
            expireDate: data.expireDate || '',
            urgencyLevel: data.urgencyLevel ?? 0,
            tags: data.tags || '',
            changeSummary: '',
            currentVersion: data.currentVersion || null,
            files: [],
            existingAttachments: data.attachments || []
          });
        } catch (error) {
          ElMessage.error(error.message || '加载详情失败');
          return;
        }
      } else {
        isEdit.value = false;
        Object.assign(form, {
          id: null,
          categoryId: selectedCategoryId.value || '',
          title: '',
          content: '',
          documentNumber: '',
          issuingAuthority: '',
          effectiveDate: '',
          expireDate: '',
          urgencyLevel: 0,
          tags: '',
          changeSummary: '',
          currentVersion: null,
          files: [],
          existingAttachments: []
        });
      }
      showFormModal.value = true;
    };
    const closeFormModal = () => {
      showFormModal.value = false;
    };

    // 选择附件
    const handleAttachmentSelect = e => {
      const files = Array.from(e.target.files || []);
      const validTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
      for (const file of files) {
        if (!validTypes.includes(file.type)) {
          ElMessage.warning(`文件 "${file.name}" 格式不支持，仅支持 PDF、DOC、DOCX`);
          continue;
        }
        form.files.push(file);
      }
      e.target.value = ''; // 清空 input 以便重复选择同一文件
    };

    // 移除待上传的新文件
    const removeNewFile = idx => {
      form.files.splice(idx, 1);
    };

    // 删除已有附件
    const removeExistingAttachment = att => {
      form.existingAttachments = form.existingAttachments.filter(a => a.id !== att.id);
    };

    // 格式化文件大小
    const formatFileSize = bytes => {
      if (!bytes) return '-';
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
      return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    };
    const submitForm = async () => {
      if (!form.title.trim()) {
        ElMessage.warning('请输入标题');
        return;
      }
      if (!form.categoryId) {
        ElMessage.warning('请选择分类');
        return;
      }
      if (!form.content || form.content === '<p></p>') {
        ElMessage.warning('请输入正文内容');
        return;
      }
      formSubmitting.value = true;
      try {
        if (isEdit.value) {
          // 编辑模式：先上传新附件，再一次性提交所有更新
          const newAttachments = [];
          for (let i = 0; i < form.files.length; i++) {
            const file = form.files[i];
            const uploadRes = await uploadFile(file, 'policy', 'public');
            const ext = file.name.split('.').pop()?.toLowerCase() || '';
            newAttachments.push({
              fileName: file.name,
              fileKey: uploadRes.fileName,
              fileSize: file.size,
              fileType: ext,
              sort: form.existingAttachments.length + i
            });
          }
          await updatePolicyRegulation(form.id, {
            id: form.id,
            categoryId: form.categoryId,
            title: form.title,
            content: form.content,
            issuingAuthority: form.issuingAuthority,
            docNumber: form.documentNumber,
            effectiveDate: form.effectiveDate || null,
            expiryDate: form.expireDate || null,
            urgencyLevel: form.urgencyLevel,
            currentVersion: form.currentVersion,
            keepAttachmentIds: form.existingAttachments.map(a => a.id),
            newAttachments
          });
          ElMessage.success('法规更新成功');
        } else {
          // 新增模式：先上传附件，再创建法规
          const attachments = [];
          for (let i = 0; i < form.files.length; i++) {
            const file = form.files[i];
            const uploadRes = await uploadFile(file, 'policy', 'public');
            const ext = file.name.split('.').pop()?.toLowerCase() || '';
            attachments.push({
              fileName: file.name,
              fileKey: uploadRes.fileName,
              fileSize: file.size,
              fileType: ext,
              sort: i
            });
          }
          await createPolicyRegulation({
            categoryId: form.categoryId,
            title: form.title,
            content: form.content,
            issuingAuthority: form.issuingAuthority,
            docNumber: form.documentNumber,
            effectiveDate: form.effectiveDate || null,
            expiryDate: form.expireDate || null,
            urgencyLevel: form.urgencyLevel,
            attachments
          });
          ElMessage.success('法规创建成功');
        }
        closeFormModal();
        await loadList(pageInfo.current);
      } catch (error) {
        ElMessage.error(error.message || '保存失败');
      } finally {
        formSubmitting.value = false;
      }
    };

    // ==================== 详情 ====================
    const showDetailModal = ref(false);
    const detailData = ref(null);
    const detailLoading = ref(false);
    const previewLoading = reactive({});
    const openDetailModal = async item => {
      showDetailModal.value = true;
      detailLoading.value = true;
      try {
        detailData.value = await getPolicyRegulationDetail(item.id);
      } catch (error) {
        ElMessage.error(error.message || '加载详情失败');
      } finally {
        detailLoading.value = false;
      }
    };

    // 下载附件
    const handleDownload = async att => {
      try {
        const blob = await downloadPolicyAttachment(att.id);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = att.fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        ElMessage.error(error.message || '下载失败');
      }
    };

    // 预览附件
    const showPreviewModal = ref(false);
    const previewUrl = ref('');
    const previewFileName = ref('');
    const handlePreview = async att => {
      // 仅支持 PDF 预览，其他格式提示下载
      const ext = att.fileType?.toLowerCase();
      if (ext !== 'pdf') {
        ElMessage.warning('仅支持 PDF 文件预览，其他格式请下载后查看');
        return;
      }
      previewLoading[att.id] = true;
      try {
        const response = await previewPolicyAttachment(att.id);
        // 释放之前的 URL
        if (previewUrl.value) {
          window.URL.revokeObjectURL(previewUrl.value);
        }
        const blob = new Blob([response], {
          type: 'application/pdf'
        });
        previewUrl.value = window.URL.createObjectURL(blob);
        previewFileName.value = att.fileName;
        showPreviewModal.value = true;
      } catch (error) {
        ElMessage.error(error.message || '预览加载失败');
      } finally {
        previewLoading[att.id] = false;
      }
    };
    const closePreviewModal = () => {
      showPreviewModal.value = false;
      if (previewUrl.value) {
        window.URL.revokeObjectURL(previewUrl.value);
        previewUrl.value = '';
      }
      previewFileName.value = '';
    };

    // ==================== 小程序预览 ====================
    const showMpPreviewModal = ref(false);
    const previewItemId = ref(null);
    const previewPolicyData = ref(null);

    // 列表入口：预览已保存法规（走详情接口）
    const openMpPreview = id => {
      previewPolicyData.value = null;
      previewItemId.value = id;
      showMpPreviewModal.value = true;
    };

    // 表单入口：预览当前编辑内容（含未保存修改），字段名映射回 API 形状
    const openFormMpPreview = () => {
      previewItemId.value = null;
      previewPolicyData.value = {
        title: form.title,
        status: form.id ? null : 0,
        docNumber: form.documentNumber,
        issuingAuthority: form.issuingAuthority,
        effectiveDate: form.effectiveDate,
        expireDate: form.expireDate,
        urgencyLevel: form.urgencyLevel,
        tags: form.tags,
        content: form.content,
        attachments: [...form.existingAttachments, ...form.files.map(f => ({
          fileName: f.name,
          fileSize: f.size,
          fileType: f.name.split('.').pop()?.toLowerCase() || ''
        }))]
      };
      showMpPreviewModal.value = true;
    };

    // ==================== 操作 ====================
    const openMoreId = ref(null);
    const openMoreItem = ref(null);
    const moreMenuPos = reactive({
      top: 0,
      left: 0
    });
    const moreBtnRefs = {};
    const moreMenuStyle = computed(() => ({
      top: `${moreMenuPos.top}px`,
      left: `${moreMenuPos.left}px`
    }));
    const setMoreBtnRef = (id, el) => {
      if (el) moreBtnRefs[id] = el;
    };
    const toggleMoreMenu = (id, event) => {
      if (openMoreId.value === id) {
        openMoreId.value = null;
        openMoreItem.value = null;
      } else {
        const item = dataList.value.find(f => f.id === id);
        openMoreItem.value = item;
        openMoreId.value = id;
        // 计算菜单位置
        const btn = event.currentTarget;
        const rect = btn.getBoundingClientRect();
        moreMenuPos.top = rect.bottom + 4;
        moreMenuPos.left = rect.right - 176; // 176 = w-44 (11rem)
      }
    };
    const handleClickOutside = e => {
      if (openMoreId.value && !e.target.closest('.more-menu-container')) {
        openMoreId.value = null;
        openMoreItem.value = null;
      }
    };
    const handlePublish = async item => {
      openMoreId.value = null;
      try {
        await publishPolicyRegulation(item.id);
        ElMessage.success('发布成功');
        await loadList(pageInfo.current);
      } catch (error) {
        ElMessage.error(error.message || '发布失败');
      }
    };
    const handleInvalidate = async item => {
      openMoreId.value = null;
      try {
        await invalidatePolicyRegulation(item.id);
        ElMessage.success('已标记失效');
        await loadList(pageInfo.current);
      } catch (error) {
        ElMessage.error(error.message || '操作失败');
      }
    };

    // ==================== 通知 ====================
    const showNotifyModal = ref(false);
    const notifyTarget = ref(null);
    const notifyForm = reactive({
      scope: 0,
      scopeTargetInput: '',
      scopeDeptList: []
    });
    const openNotifyModal = item => {
      openMoreId.value = null;
      notifyTarget.value = item;
      Object.assign(notifyForm, {
        scope: 0,
        scopeTargetInput: '',
        scopeDeptList: []
      });
      showNotifyModal.value = true;
    };
    const submitNotify = async () => {
      const scopeTarget = notifyForm.scope === 0 ? [] : notifyForm.scope === 2 ? notifyForm.scopeDeptList.map(d => typeof d === 'object' ? d.id : d).filter(id => id != null) : notifyForm.scopeTargetInput.split(',').map(s => s.trim()).filter(Boolean);
      if (notifyForm.scope !== 0 && !scopeTarget.length) {
        ElMessage.warning('请选择通知目标');
        return;
      }
      try {
        await sendPolicyNotify(notifyTarget.value.id, {
          scope: notifyForm.scope,
          scopeTarget
        });
        ElMessage.success('通知发送成功');
        showNotifyModal.value = false;
      } catch (error) {
        ElMessage.error(error.message || '通知发送失败');
      }
    };

    // ==================== 替代链 ====================
    const showChainModal = ref(false);
    const chainList = ref([]);
    const chainLoading = ref(false);
    const chainTarget = ref(null);
    const openSupersedChain = async item => {
      openMoreId.value = null;
      chainTarget.value = item;
      showChainModal.value = true;
      chainLoading.value = true;
      try {
        chainList.value = await getPolicySupersederChain(item.id);
      } catch (error) {
        ElMessage.error(error.message || '加载替代链失败');
      } finally {
        chainLoading.value = false;
      }
    };

    // ==================== 版本历史 ====================
    const showVersionDrawer = ref(false);
    const versionList = ref([]);
    const versionLoading = ref(false);
    const versionTarget = ref(null);
    const openVersionDrawer = async item => {
      versionTarget.value = item;
      showVersionDrawer.value = true;
      versionLoading.value = true;
      try {
        versionList.value = await getPolicyVersions(item.id);
      } catch (error) {
        ElMessage.error(error.message || '加载版本失败');
      } finally {
        versionLoading.value = false;
      }
    };
    const handleRollback = async version => {
      try {
        await rollbackPolicyRegulation(versionTarget.value.id, version.versionNo);
        ElMessage.success('回滚成功');
        showVersionDrawer.value = false;
        await loadList(pageInfo.current);
      } catch (error) {
        ElMessage.error(error.message || '回滚失败');
      }
    };

    // 查看指定版本详情
    const viewVersionDetail = async version => {
      showDetailModal.value = true;
      detailLoading.value = true;
      try {
        detailData.value = await getPolicyVersionDetail(versionTarget.value.id, version.versionNo);
      } catch (error) {
        ElMessage.error(error.message || '加载版本详情失败');
      } finally {
        detailLoading.value = false;
      }
    };

    // ==================== 删除 ====================
    const showConfirmModal = ref(false);
    const confirmMessage = ref('');
    const confirmPayload = ref({
      type: '',
      id: null
    });
    const confirmDeleteCategory = node => {
      confirmPayload.value = {
        type: 'category',
        id: node.id
      };
      confirmMessage.value = `确认删除分类「${node.name}」？`;
      showConfirmModal.value = true;
    };
    const confirmDeleteItem = item => {
      openMoreId.value = null;
      confirmPayload.value = {
        type: 'policy',
        id: item.id
      };
      confirmMessage.value = `确认删除政策法规「${item.title}」？`;
      showConfirmModal.value = true;
    };
    const confirmDeleteAction = async () => {
      const {
        type,
        id
      } = confirmPayload.value;
      try {
        if (type === 'category') {
          await deletePolicyCategory(id);
          ElMessage.success('分类已删除');
          await loadCategories();
        } else {
          await deletePolicyRegulation(id);
          ElMessage.success('法规已删除');
          await loadList(pageInfo.current);
        }
      } catch (error) {
        ElMessage.error(error.message || '删除失败');
      } finally {
        showConfirmModal.value = false;
      }
    };

    // ==================== 初始化 ====================
    onMounted(async () => {
      document.addEventListener('click', handleClickOutside);
      await loadCategories();
      await loadList(1);
    });
    onUnmounted(() => {
      document.removeEventListener('click', handleClickOutside);
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _directive_permission = _resolveDirective("permission");
      const _directive_safe_html = _resolveDirective("safe-html");
      const _directive_modal_a11y = _resolveDirective("modal-a11y");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [...(_cache[46] || (_cache[46] = [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal"
        }, [_createElementVNode("div", {
          class: "list-page-heading"
        }, [_createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "政策法规"), _createElementVNode("p", {
          class: "list-page-description"
        }, "管理政策法规的发布、版本流转与通知推送。")])])], -1)]))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(KbCategoryTree, {
          tree: _unref(categoryTree),
          loading: _unref(categoryLoading),
          "selected-id": _unref(selectedCategoryId),
          title: "法规分类",
          description: "按类型分类管理政策法规。",
          onAdd: _unref(handleAddCategory),
          onAddChild: _unref(handleAddChildCategory),
          onEdit: _unref(handleEditCategory),
          onDelete: confirmDeleteCategory,
          onSelect: handleCategoryTreeSelect
        }, null, 8, ["tree", "loading", "selected-id", "onAdd", "onAddChild", "onEdit"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": true,
          "refresh-loading": listLoading.value,
          onRefresh: _cache[6] || (_cache[6] = $event => loadList(pageInfo.current))
        }, {
          searchActionsLeading: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: _cache[4] || (_cache[4] = $event => openFormModal()),
            class: "btn-primary"
          }, [...(_cache[48] || (_cache[48] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4v16m8-8H4"
          })], -1), _createTextVNode(" 新增法规 ", -1)]))])), [[_directive_permission, 'kb:policy:edit']])]),
          searchActions: _withCtx(() => [_createElementVNode("button", {
            onClick: _cache[5] || (_cache[5] = $event => loadList(1)),
            class: "btn-primary"
          }, "搜索"), _createElementVNode("button", {
            onClick: resetFilters,
            class: "btn-secondary"
          }, "重置")]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchKeyword.value = $event),
            type: "text",
            placeholder: "搜索标题或文号",
            class: "form-search-input form-control-sm w-full",
            onKeyup: _cache[1] || (_cache[1] = _withKeys($event => loadList(1), ["enter"]))
          }, null, 544), [[_vModelText, searchKeyword.value]]), _cache[47] || (_cache[47] = _createElementVNode("svg", {
            class: "absolute left-3 top-2.5 h-4 w-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          })], -1))]), _createVNode(_component_el_select, {
            modelValue: searchStatus.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => searchStatus.value = $event),
            placeholder: "请选择状态",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部状态",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "草稿",
              value: "0"
            }), _createVNode(_component_el_option, {
              label: "已发布",
              value: "1"
            }), _createVNode(_component_el_option, {
              label: "已失效",
              value: "2"
            })]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_select, {
            modelValue: searchUrgency.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => searchUrgency.value = $event),
            placeholder: "请选择级别",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部级别",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "普通",
              value: "0"
            }), _createVNode(_component_el_option, {
              label: "重要",
              value: "1"
            }), _createVNode(_component_el_option, {
              label: "紧急",
              value: "2"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("table", _hoisted_8, [_cache[55] || (_cache[55] = _createElementVNode("thead", {
          class: "data-table-head"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "px-5 py-3 text-left"
        }, "标题"), _createElementVNode("th", {
          class: "px-5 py-3 text-left"
        }, "文号"), _createElementVNode("th", {
          class: "px-5 py-3 text-left"
        }, "发布机构"), _createElementVNode("th", {
          class: "px-5 py-3 text-center"
        }, "级别"), _createElementVNode("th", {
          class: "px-5 py-3 text-center"
        }, "状态"), _createElementVNode("th", {
          class: "px-5 py-3 text-center"
        }, "生效日期"), _createElementVNode("th", {
          class: "px-5 py-3 text-center"
        }, "版本"), _createElementVNode("th", {
          class: "px-5 py-3 text-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作")])], -1)), _createElementVNode("tbody", null, [listLoading.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(5, n => {
          return _createElementVNode("tr", {
            key: n,
            class: "data-table-row"
          }, [...(_cache[49] || (_cache[49] = [_createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton h-4 w-40"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton h-4 w-28"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton h-4 w-20"
          })], -1), _createElementVNode("td", {
            class: "data-table-td text-center"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton mx-auto h-5 w-10 rounded-full"
          })], -1), _createElementVNode("td", {
            class: "data-table-td text-center"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton mx-auto h-5 w-14 rounded-full"
          })], -1), _createElementVNode("td", {
            class: "data-table-td text-center"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton mx-auto h-4 w-20"
          })], -1), _createElementVNode("td", {
            class: "data-table-td text-center"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton mx-auto h-4 w-8"
          })], -1), _createElementVNode("td", {
            class: "data-table-td data-table-sticky-right data-table-sticky-action"
          }, [_createElementVNode("div", {
            class: "mx-auto flex justify-center gap-2"
          }, [_createElementVNode("div", {
            class: "data-table-skeleton h-7 w-7 rounded-full"
          }), _createElementVNode("div", {
            class: "data-table-skeleton h-7 w-7 rounded-full"
          })])], -1)]))]);
        }), 64)) : !dataList.value.length ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [...(_cache[50] || (_cache[50] = [_createElementVNode("td", {
          colspan: "8",
          class: "px-5 py-8 text-center text-sm text-slate-500"
        }, "暂无政策法规数据", -1)]))])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, item => {
          return _openBlock(), _createElementBlock("tr", {
            key: item.id,
            class: "data-table-row"
          }, [_createElementVNode("td", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(item.title), 1), item.tags ? (_openBlock(), _createElementBlock("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.tags.split(',').slice(0, 3), tag => {
            return _openBlock(), _createElementBlock("span", {
              key: tag,
              class: "data-table-inline-tag"
            }, _toDisplayString(tag.trim()), 1);
          }), 128))])) : _createCommentVNode("", true)])]), _createElementVNode("td", _hoisted_14, _toDisplayString(item.docNumber || '-'), 1), _createElementVNode("td", _hoisted_15, _toDisplayString(item.issuingAuthority || '-'), 1), _createElementVNode("td", _hoisted_16, [_createElementVNode("span", {
            class: _normalizeClass(urgencyClass(item.urgencyLevel))
          }, _toDisplayString(urgencyText(item.urgencyLevel)), 3)]), _createElementVNode("td", _hoisted_17, [_createElementVNode("span", {
            class: _normalizeClass(policyStatusClass(item.status))
          }, _toDisplayString(policyStatusText(item.status)), 3)]), _createElementVNode("td", _hoisted_18, _toDisplayString(item.effectiveDate || '-'), 1), _createElementVNode("td", _hoisted_19, [_createElementVNode("button", {
            onClick: $event => openVersionDrawer(item),
            class: "text-xs text-primary-600 hover:text-primary-700 hover:underline"
          }, "v" + _toDisplayString(item.currentVersion || 1), 9, _hoisted_20)]), _createElementVNode("td", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("button", {
            onClick: $event => openDetailModal(item),
            class: "table-action-button is-primary",
            title: "查看详情",
            "aria-label": "查看详情"
          }, [...(_cache[51] || (_cache[51] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          }), _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          })], -1)]))], 8, _hoisted_23), _createElementVNode("button", {
            onClick: $event => openMpPreview(item.id),
            class: "table-action-button is-teal",
            title: "小程序预览",
            "aria-label": "小程序预览"
          }, [...(_cache[52] || (_cache[52] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
          })], -1)]))], 8, _hoisted_24), _withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: $event => openFormModal(item),
            class: "table-action-button is-primary",
            title: "编辑",
            "aria-label": "编辑"
          }, [...(_cache[53] || (_cache[53] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
          })], -1)]))], 8, _hoisted_25)), [[_directive_permission, 'kb:policy:edit']]), _createElementVNode("div", _hoisted_26, [_createElementVNode("button", {
            ref_for: true,
            ref: el => setMoreBtnRef(item.id, el),
            onClick: _withModifiers($event => toggleMoreMenu(item.id, $event), ["stop"]),
            class: "table-action-button is-neutral",
            title: "更多"
          }, [...(_cache[54] || (_cache[54] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
          })], -1)]))], 8, _hoisted_27)])])])]);
        }), 128))])])])]), pageInfo.total > 0 ? (_openBlock(), _createBlock(AppPagination, {
          key: 0,
          class: "pagination-bridge",
          pagination: pageInfo,
          size: pageSize.value,
          "page-sizes": [10, 20, 50],
          onPageChange: handlePageChange,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["pagination", "size"])) : _createCommentVNode("", true)])])]), _createVNode(_Transition, {
          name: "modal"
        }, {
          default: _withCtx(() => [_createVNode(AppModal, {
            visible: _unref(showCategoryModal),
            size: "md",
            "panel-class": "ring-1 ring-black/5",
            onClose: _unref(closeCategoryModal)
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_28, [_cache[57] || (_cache[57] = _createElementVNode("div", {
              class: "absolute inset-0 bg-grid-white/10"
            }, null, -1)), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", null, [_createElementVNode("h3", _hoisted_30, _toDisplayString(_unref(isCategoryEdit) ? '编辑分类' : '新增分类'), 1), _createElementVNode("p", _hoisted_31, _toDisplayString(_unref(isCategoryEdit) ? '修改分类信息' : '创建新的法规分类'), 1)]), _createElementVNode("button", {
              onClick: _cache[7] || (_cache[7] = (...args) => _unref(closeCategoryModal) && _unref(closeCategoryModal)(...args)),
              class: "cursor-pointer rounded-full p-1.5 text-white/80 transition-colors hover:bg-white/20 hover:text-white"
            }, [...(_cache[56] || (_cache[56] = [_createElementVNode("svg", {
              class: "h-5 w-5",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M6 18L18 6M6 6l12 12"
            })], -1)]))])])]), _createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_cache[58] || (_cache[58] = _createElementVNode("label", {
              class: "flex items-center gap-1 text-sm font-medium text-slate-700"
            }, [_createElementVNode("svg", {
              class: "h-4 w-4 text-slate-400",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
            })]), _createTextVNode(" 分类名称 "), _createElementVNode("span", {
              class: "text-red-500"
            }, "*")], -1)), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _unref(categoryForm).name = $event),
              class: "form-input",
              placeholder: "请输入分类名称"
            }, null, 512), [[_vModelText, _unref(categoryForm).name]])]), _createElementVNode("div", _hoisted_34, [_cache[59] || (_cache[59] = _createElementVNode("label", {
              class: "flex items-center gap-1 text-sm font-medium text-slate-700"
            }, [_createElementVNode("svg", {
              class: "h-4 w-4 text-slate-400",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
            })]), _createTextVNode(" 上级分类 ")], -1)), _createVNode(_component_el_select, {
              modelValue: _unref(categoryForm).parentId,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _unref(categoryForm).parentId = $event),
              class: "form-select"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "顶级分类",
                value: 0
              }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(flatCategories), cat => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: cat.id,
                  label: cat.label,
                  value: cat.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])])]), _cache[63] || (_cache[63] = _createElementVNode("div", {
              class: "mx-6 border-t border-dashed border-slate-200"
            }, null, -1)), _createElementVNode("div", _hoisted_35, [_cache[62] || (_cache[62] = _createElementVNode("p", {
              class: "text-xs font-medium text-slate-400 uppercase tracking-wider"
            }, "可选信息", -1)), _createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_cache[60] || (_cache[60] = _createElementVNode("label", {
              class: "flex items-center gap-1 text-sm font-medium text-slate-700"
            }, [_createElementVNode("svg", {
              class: "h-4 w-4 text-slate-400",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"
            })]), _createTextVNode(" 排序号 ")], -1)), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _unref(categoryForm).sort = $event),
              type: "number",
              class: "form-input",
              placeholder: "0"
            }, null, 512), [[_vModelText, _unref(categoryForm).sort, void 0, {
              number: true
            }]])]), _createElementVNode("div", _hoisted_38, [_cache[61] || (_cache[61] = _createElementVNode("label", {
              class: "flex items-center gap-1 text-sm font-medium text-slate-700"
            }, [_createElementVNode("svg", {
              class: "h-4 w-4 text-slate-400",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            })]), _createTextVNode(" 状态 ")], -1)), _createVNode(_component_el_select, {
              modelValue: _unref(categoryForm).status,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _unref(categoryForm).status = $event),
              class: "form-select"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "启用",
                value: 0
              }), _createVNode(_component_el_option, {
                label: "停用",
                value: 1
              })]),
              _: 1
            }, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_39, [_createElementVNode("button", {
              onClick: _cache[12] || (_cache[12] = (...args) => _unref(closeCategoryModal) && _unref(closeCategoryModal)(...args)),
              class: "btn-secondary"
            }, "取消"), _createElementVNode("button", {
              onClick: _cache[13] || (_cache[13] = (...args) => _unref(submitCategory) && _unref(submitCategory)(...args)),
              class: "btn-primary hover:shadow-md hover:shadow-primary-500/30"
            }, _toDisplayString(_unref(isCategoryEdit) ? '保存修改' : '创建分类'), 1)])]),
            _: 1
          }, 8, ["visible", "onClose"])]),
          _: 1
        }), _createVNode(AppModal, {
          visible: showFormModal.value,
          size: "4xl",
          "panel-class": "ring-1 ring-black/5",
          onClose: closeFormModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_40, [_cache[65] || (_cache[65] = _createElementVNode("div", {
            class: "absolute inset-0 bg-grid-white/10"
          }, null, -1)), _createElementVNode("div", _hoisted_41, [_createElementVNode("div", null, [_createElementVNode("h3", _hoisted_42, _toDisplayString(isEdit.value ? '编辑政策法规' : '新增政策法规'), 1), _createElementVNode("p", _hoisted_43, _toDisplayString(isEdit.value ? '编辑将自动产生新版本记录' : '创建新的政策法规'), 1)]), _createElementVNode("button", {
            onClick: closeFormModal,
            class: "rounded-full p-1.5 text-white/80 transition-colors hover:bg-white/20 hover:text-white"
          }, [...(_cache[64] || (_cache[64] = [_createElementVNode("svg", {
            class: "h-5 w-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])])]), _createElementVNode("div", _hoisted_44, [_createElementVNode("div", _hoisted_45, [_cache[71] || (_cache[71] = _createElementVNode("div", {
            class: "flex items-center gap-2 text-sm font-medium text-slate-900"
          }, [_createElementVNode("div", {
            class: "flex h-6 w-6 items-center justify-center rounded-full bg-primary-100 text-primary-600"
          }, [_createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          })])]), _createTextVNode(" 基本信息 ")], -1)), _createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_cache[66] || (_cache[66] = _createElementVNode("label", {
            class: "flex items-center gap-1 text-sm font-medium text-slate-700"
          }, [_createElementVNode("svg", {
            class: "h-4 w-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          })]), _createTextVNode(" 标题 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => form.title = $event),
            class: "form-input",
            placeholder: "请输入政策法规标题"
          }, null, 512), [[_vModelText, form.title]])]), _createElementVNode("div", _hoisted_48, [_cache[67] || (_cache[67] = _createElementVNode("label", {
            class: "flex items-center gap-1 text-sm font-medium text-slate-700"
          }, [_createElementVNode("svg", {
            class: "h-4 w-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
          })]), _createTextVNode(" 所属分类 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(_component_el_select, {
            modelValue: form.categoryId,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => form.categoryId = $event),
            class: "form-select"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "请选择分类",
              value: ""
            }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(flatCategories), cat => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: cat.id,
                label: cat.label,
                value: cat.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_49, [_cache[68] || (_cache[68] = _createElementVNode("label", {
            class: "text-sm font-medium text-slate-700"
          }, "文号", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => form.documentNumber = $event),
            class: "form-input",
            placeholder: "如 国发〔2024〕1号"
          }, null, 512), [[_vModelText, form.documentNumber]])]), _createElementVNode("div", _hoisted_50, [_cache[69] || (_cache[69] = _createElementVNode("label", {
            class: "text-sm font-medium text-slate-700"
          }, "发布机构", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => form.issuingAuthority = $event),
            class: "form-input",
            placeholder: "发布机构名称"
          }, null, 512), [[_vModelText, form.issuingAuthority]])]), _createElementVNode("div", _hoisted_51, [_cache[70] || (_cache[70] = _createElementVNode("label", {
            class: "text-sm font-medium text-slate-700"
          }, "紧急程度", -1)), _createVNode(_component_el_select, {
            modelValue: form.urgencyLevel,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => form.urgencyLevel = $event),
            class: "form-select"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "普通",
              value: 0
            }), _createVNode(_component_el_option, {
              label: "重要",
              value: 1
            }), _createVNode(_component_el_option, {
              label: "紧急",
              value: 2
            })]),
            _: 1
          }, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_52, [_cache[74] || (_cache[74] = _createElementVNode("div", {
            class: "flex items-center gap-2 text-sm font-medium text-slate-900"
          }, [_createElementVNode("div", {
            class: "flex h-6 w-6 items-center justify-center rounded-full bg-primary-100 text-primary-600"
          }, [_createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
          })])]), _createTextVNode(" 有效期 ")], -1)), _createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_cache[72] || (_cache[72] = _createElementVNode("label", {
            class: "text-sm font-medium text-slate-700"
          }, "生效日期", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => form.effectiveDate = $event),
            type: "date",
            class: "form-input"
          }, null, 512), [[_vModelText, form.effectiveDate]])]), _createElementVNode("div", _hoisted_55, [_cache[73] || (_cache[73] = _createElementVNode("label", {
            class: "text-sm font-medium text-slate-700"
          }, "失效日期", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => form.expireDate = $event),
            type: "date",
            class: "form-input"
          }, null, 512), [[_vModelText, form.expireDate]])])])]), _createElementVNode("div", _hoisted_56, [_cache[75] || (_cache[75] = _createElementVNode("div", {
            class: "flex items-center gap-2 text-sm font-medium text-slate-900"
          }, [_createElementVNode("div", {
            class: "flex h-6 w-6 items-center justify-center rounded-full bg-primary-100 text-primary-600"
          }, [_createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M4 6h16M4 12h16M4 18h7"
          })])]), _createTextVNode(" 正文内容 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(RichTextEditor, {
            modelValue: form.content,
            "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => form.content = $event),
            "min-height": "240px",
            "upload-module": "policy"
          }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, [_cache[76] || (_cache[76] = _createElementVNode("label", {
            class: "text-sm font-medium text-slate-700"
          }, "标签", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => form.tags = $event),
            class: "form-input",
            placeholder: "多个标签用逗号分隔"
          }, null, 512), [[_vModelText, form.tags]])]), isEdit.value ? (_openBlock(), _createElementBlock("div", _hoisted_59, [_cache[77] || (_cache[77] = _createElementVNode("label", {
            class: "text-sm font-medium text-slate-700"
          }, "修订说明", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => form.changeSummary = $event),
            class: "form-input",
            placeholder: "简要说明本次修改内容"
          }, null, 512), [[_vModelText, form.changeSummary]])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_60, [_cache[85] || (_cache[85] = _createElementVNode("div", {
            class: "flex items-center gap-2 text-sm font-medium text-slate-900"
          }, [_createElementVNode("div", {
            class: "flex h-6 w-6 items-center justify-center rounded-full bg-primary-100 text-primary-600"
          }, [_createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
          })])]), _createTextVNode(" 附件文件 ")], -1)), _createElementVNode("div", _hoisted_61, [isEdit.value && form.existingAttachments.length ? (_openBlock(), _createElementBlock("div", _hoisted_62, [_cache[79] || (_cache[79] = _createElementVNode("div", {
            class: "flex items-center gap-2 text-xs font-medium text-slate-500"
          }, [_createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M5 13l4 4L19 7"
          })]), _createTextVNode(" 已有附件 ")], -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.existingAttachments, att => {
            return _openBlock(), _createElementBlock("div", {
              key: att.id,
              class: "group flex items-center justify-between rounded-lg border border-slate-200 bg-white px-4 py-3 transition-all hover:border-slate-300 hover:shadow-sm"
            }, [_createElementVNode("div", _hoisted_63, [_cache[78] || (_cache[78] = _createElementVNode("div", {
              class: "flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-slate-100 text-slate-500"
            }, [_createElementVNode("svg", {
              class: "h-5 w-5",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            })])], -1)), _createElementVNode("div", _hoisted_64, [_createElementVNode("div", _hoisted_65, _toDisplayString(att.fileName), 1), _createElementVNode("div", _hoisted_66, _toDisplayString(formatFileSize(att.fileSize)), 1)])]), _createElementVNode("button", {
              type: "button",
              onClick: $event => removeExistingAttachment(att),
              class: "btn-text-danger opacity-0 transition-opacity group-hover:opacity-100"
            }, "删除", 8, _hoisted_67)]);
          }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", null, [_createElementVNode("label", _hoisted_68, [_cache[80] || (_cache[80] = _createElementVNode("div", {
            class: "flex h-12 w-12 items-center justify-center rounded-full bg-slate-100 text-slate-400 transition-colors group-hover:bg-primary-100 group-hover:text-primary-600"
          }, [_createElementVNode("svg", {
            class: "h-6 w-6",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
          })])], -1)), _cache[81] || (_cache[81] = _createElementVNode("p", {
            class: "mt-3 text-sm font-medium text-slate-700 group-hover:text-primary-700"
          }, "点击选择文件上传", -1)), _cache[82] || (_cache[82] = _createElementVNode("p", {
            class: "mt-1 text-xs text-slate-500"
          }, "支持 PDF、DOC、DOCX 格式，可上传多个文件", -1)), _createElementVNode("input", {
            type: "file",
            class: "hidden",
            multiple: "",
            accept: ".pdf,.doc,.docx",
            onChange: handleAttachmentSelect
          }, null, 32)])]), form.files.length ? (_openBlock(), _createElementBlock("div", _hoisted_69, [_cache[84] || (_cache[84] = _createElementVNode("div", {
            class: "flex items-center gap-2 text-xs font-medium text-primary-600"
          }, [_createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
          })]), _createTextVNode(" 待上传 ")], -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.files, (file, idx) => {
            return _openBlock(), _createElementBlock("div", {
              key: idx,
              class: "group flex items-center justify-between rounded-lg border border-primary-200 bg-primary-50/50 px-4 py-3 transition-all"
            }, [_createElementVNode("div", _hoisted_70, [_cache[83] || (_cache[83] = _createElementVNode("div", {
              class: "flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-600"
            }, [_createElementVNode("svg", {
              class: "h-5 w-5",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            })])], -1)), _createElementVNode("div", _hoisted_71, [_createElementVNode("div", _hoisted_72, _toDisplayString(file.name), 1), _createElementVNode("div", _hoisted_73, _toDisplayString(formatFileSize(file.size)), 1)])]), _createElementVNode("button", {
              onClick: $event => removeNewFile(idx),
              class: "cursor-pointer rounded-lg px-3 py-1.5 text-xs font-medium text-red-600 transition-all hover:bg-red-50"
            }, "移除", 8, _hoisted_74)]);
          }), 128))])) : _createCommentVNode("", true)])])]), _createElementVNode("div", {
            class: "flex justify-end gap-3 border-t border-slate-100 bg-slate-50/50 px-6 py-4"
          }, [_createElementVNode("button", {
            onClick: openFormMpPreview,
            class: "rounded-lg border border-primary-200 px-4 py-2 text-sm text-primary-700 hover:bg-primary-50"
          }, "预览小程序效果"), _createElementVNode("button", {
            onClick: closeFormModal,
            class: "cursor-pointer rounded-lg border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-600 transition-all hover:bg-slate-50 hover:text-slate-900"
          }, "取消"), _createElementVNode("button", {
            onClick: submitForm,
            class: "cursor-pointer rounded-lg bg-primary-700 px-5 py-2 text-sm font-medium text-white shadow-sm shadow-primary-600/30 transition-all hover:bg-primary-800 hover:shadow-md hover:shadow-primary-600/40"
          }, "保存")])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showDetailModal.value,
          size: "3xl",
          "panel-class": "ring-1 ring-black/5",
          "z-index": 60,
          onClose: _cache[25] || (_cache[25] = $event => showDetailModal.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_75, [_cache[88] || (_cache[88] = _createElementVNode("div", {
            class: "absolute inset-0 bg-grid-white/10"
          }, null, -1)), _createElementVNode("div", _hoisted_76, [_cache[87] || (_cache[87] = _createElementVNode("div", null, [_createElementVNode("h3", {
            class: "text-lg font-semibold text-white"
          }, "政策法规详情"), _createElementVNode("p", {
            class: "mt-0.5 text-sm text-primary-100"
          }, "查看完整的法规信息和正文内容")], -1)), _createElementVNode("button", {
            onClick: _cache[24] || (_cache[24] = $event => showDetailModal.value = false),
            class: "rounded-full p-1.5 text-white/80 transition-colors hover:bg-white/20 hover:text-white"
          }, [...(_cache[86] || (_cache[86] = [_createElementVNode("svg", {
            class: "h-5 w-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])])]), _createElementVNode("div", _hoisted_77, [detailLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_78, [...(_cache[89] || (_cache[89] = [_createElementVNode("div", {
            class: "h-6 w-3/4 rounded bg-slate-200"
          }, null, -1), _createElementVNode("div", {
            class: "h-4 w-1/2 rounded bg-slate-200"
          }, null, -1), _createElementVNode("div", {
            class: "h-40 rounded bg-slate-200"
          }, null, -1)]))])) : detailData.value ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createElementVNode("div", _hoisted_79, [_createElementVNode("span", {
            class: _normalizeClass(policyStatusClass(detailData.value.status))
          }, _toDisplayString(policyStatusText(detailData.value.status)), 3), _createElementVNode("span", {
            class: _normalizeClass(urgencyClass(detailData.value.urgencyLevel))
          }, _toDisplayString(urgencyText(detailData.value.urgencyLevel)), 3), _createElementVNode("span", _hoisted_80, "v" + _toDisplayString(detailData.value.currentVersion), 1)]), _createElementVNode("h2", _hoisted_81, _toDisplayString(detailData.value.title), 1), _createElementVNode("div", _hoisted_82, [detailData.value.docNumber ? (_openBlock(), _createElementBlock("div", _hoisted_83, [_cache[90] || (_cache[90] = _createElementVNode("svg", {
            class: "h-4 w-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M7 20l4-16m2 16l4-16M6 9h14M4 15h14"
          })], -1)), _cache[91] || (_cache[91] = _createElementVNode("span", {
            class: "text-slate-500"
          }, "文号：", -1)), _createElementVNode("span", _hoisted_84, _toDisplayString(detailData.value.docNumber), 1)])) : _createCommentVNode("", true), detailData.value.issuingAuthority ? (_openBlock(), _createElementBlock("div", _hoisted_85, [_cache[92] || (_cache[92] = _createElementVNode("svg", {
            class: "h-4 w-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
          })], -1)), _cache[93] || (_cache[93] = _createElementVNode("span", {
            class: "text-slate-500"
          }, "发布机构：", -1)), _createElementVNode("span", _hoisted_86, _toDisplayString(detailData.value.issuingAuthority), 1)])) : _createCommentVNode("", true), detailData.value.effectiveDate ? (_openBlock(), _createElementBlock("div", _hoisted_87, [_cache[94] || (_cache[94] = _createElementVNode("svg", {
            class: "h-4 w-4 text-emerald-500",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
          })], -1)), _cache[95] || (_cache[95] = _createElementVNode("span", {
            class: "text-slate-500"
          }, "生效日期：", -1)), _createElementVNode("span", _hoisted_88, _toDisplayString(detailData.value.effectiveDate), 1)])) : _createCommentVNode("", true), detailData.value.expireDate ? (_openBlock(), _createElementBlock("div", _hoisted_89, [_cache[96] || (_cache[96] = _createElementVNode("svg", {
            class: "h-4 w-4 text-red-500",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
          })], -1)), _cache[97] || (_cache[97] = _createElementVNode("span", {
            class: "text-slate-500"
          }, "失效日期：", -1)), _createElementVNode("span", _hoisted_90, _toDisplayString(detailData.value.expireDate), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_91, [_cache[98] || (_cache[98] = _createElementVNode("svg", {
            class: "h-4 w-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
          })], -1)), _cache[99] || (_cache[99] = _createElementVNode("span", {
            class: "text-slate-500"
          }, "分类：", -1)), _createElementVNode("span", _hoisted_92, _toDisplayString(_unref(getCategoryName)(detailData.value.categoryId)), 1)])]), detailData.value.tags ? (_openBlock(), _createElementBlock("div", _hoisted_93, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailData.value.tags.split(',').filter(Boolean), tag => {
            return _openBlock(), _createElementBlock("span", {
              key: tag,
              class: "rounded-full bg-primary-50 px-2.5 py-1 text-xs font-medium text-primary-700"
            }, _toDisplayString(tag.trim()), 1);
          }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_94, [_cache[100] || (_cache[100] = _createElementVNode("div", {
            class: "flex items-center gap-2 text-sm font-medium text-slate-900"
          }, [_createElementVNode("div", {
            class: "flex h-6 w-6 items-center justify-center rounded-full bg-primary-100 text-primary-600"
          }, [_createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M4 6h16M4 12h16M4 18h7"
          })])]), _createTextVNode(" 正文内容 ")], -1)), _createElementVNode("div", _hoisted_95, [_withDirectives(_createElementVNode("div", _hoisted_96, null, 512), [[_directive_safe_html, detailData.value.content]])])]), detailData.value.attachments?.length ? (_openBlock(), _createElementBlock("div", _hoisted_97, [_cache[103] || (_cache[103] = _createElementVNode("div", {
            class: "flex items-center gap-2 text-sm font-medium text-slate-900"
          }, [_createElementVNode("div", {
            class: "flex h-6 w-6 items-center justify-center rounded-full bg-primary-100 text-primary-600"
          }, [_createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
          })])]), _createTextVNode(" 附件文件 ")], -1)), _createElementVNode("div", _hoisted_98, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailData.value.attachments, att => {
            return _openBlock(), _createElementBlock("div", {
              key: att.id,
              class: "group flex items-center justify-between rounded-xl border border-slate-200 bg-white px-4 py-3 transition-all hover:border-slate-300 hover:shadow-sm"
            }, [_createElementVNode("div", _hoisted_99, [_cache[101] || (_cache[101] = _createElementVNode("div", {
              class: "flex h-10 w-10 items-center justify-center rounded-lg bg-slate-100 text-slate-500"
            }, [_createElementVNode("svg", {
              class: "h-5 w-5",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            })])], -1)), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_100, _toDisplayString(att.fileName), 1), _createElementVNode("div", _hoisted_101, _toDisplayString(formatFileSize(att.fileSize)) + " · " + _toDisplayString(att.fileType?.toUpperCase()), 1)])]), _createElementVNode("div", _hoisted_102, [_createElementVNode("button", {
              class: _normalizeClass(["cursor-pointer rounded-lg px-3 py-1.5 text-xs font-medium transition-all", previewLoading[att.id] ? 'text-slate-300 cursor-not-allowed' : 'text-slate-600 hover:bg-slate-100 hover:text-slate-900']),
              disabled: previewLoading[att.id],
              onClick: $event => handlePreview(att)
            }, [previewLoading[att.id] ? (_openBlock(), _createElementBlock("span", _hoisted_104, [...(_cache[102] || (_cache[102] = [_createElementVNode("svg", {
              class: "h-3.5 w-3.5 animate-spin",
              fill: "none",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("circle", {
              class: "opacity-25",
              cx: "12",
              cy: "12",
              r: "10",
              stroke: "currentColor",
              "stroke-width": "4"
            }), _createElementVNode("path", {
              class: "opacity-75",
              fill: "currentColor",
              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            })], -1), _createTextVNode(" 加载中 ", -1)]))])) : (_openBlock(), _createElementBlock("span", _hoisted_105, "预览"))], 10, _hoisted_103), _createElementVNode("button", {
              onClick: $event => handleDownload(att),
              class: "cursor-pointer rounded-lg bg-primary-50 px-3 py-1.5 text-xs font-medium text-primary-600 transition-all hover:bg-primary-100"
            }, "下载", 8, _hoisted_106)])]);
          }), 128))])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_107, [_createElementVNode("div", _hoisted_108, [_cache[104] || (_cache[104] = _createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          })], -1)), _createTextVNode(" 创建时间：" + _toDisplayString(detailData.value.createTime || '-'), 1)]), _createElementVNode("div", _hoisted_109, [_cache[105] || (_cache[105] = _createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M5 13l4 4L19 7"
          })], -1)), _createTextVNode(" 发布时间：" + _toDisplayString(detailData.value.publishTime || '-'), 1)])])], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_110, [...(_cache[106] || (_cache[106] = [_createElementVNode("div", {
            class: "empty-state-icon"
          }, [_createElementVNode("svg", {
            class: "h-8 w-8 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          })])], -1), _createElementVNode("p", {
            class: "empty-state-title"
          }, "暂无详情数据", -1)]))]))])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showNotifyModal.value,
          size: "lg",
          "panel-class": "ring-1 ring-black/5",
          onClose: _cache[31] || (_cache[31] = $event => showNotifyModal.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_111, [_cache[109] || (_cache[109] = _createElementVNode("div", {
            class: "absolute inset-0 bg-grid-white/10"
          }, null, -1)), _createElementVNode("div", _hoisted_112, [_createElementVNode("div", null, [_cache[107] || (_cache[107] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-white"
          }, "发送通知", -1)), _createElementVNode("p", _hoisted_113, _toDisplayString(notifyTarget.value?.title), 1)]), _createElementVNode("button", {
            onClick: _cache[26] || (_cache[26] = $event => showNotifyModal.value = false),
            class: "rounded-full p-1.5 text-white/80 transition-colors hover:bg-white/20 hover:text-white"
          }, [...(_cache[108] || (_cache[108] = [_createElementVNode("svg", {
            class: "h-5 w-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])])]), _createElementVNode("div", _hoisted_114, [_createElementVNode("div", _hoisted_115, [_cache[110] || (_cache[110] = _createElementVNode("label", {
            class: "flex items-center gap-1 text-sm font-medium text-slate-700"
          }, [_createElementVNode("svg", {
            class: "h-4 w-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
          })]), _createTextVNode(" 通知范围 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(_component_el_select, {
            modelValue: notifyForm.scope,
            "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => notifyForm.scope = $event),
            class: "form-select"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全员通知",
              value: 0
            }), _createVNode(_component_el_option, {
              label: "指定角色",
              value: 1
            }), _createVNode(_component_el_option, {
              label: "指定部门",
              value: 2
            })]),
            _: 1
          }, 8, ["modelValue"])]), notifyForm.scope !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_116, [_cache[112] || (_cache[112] = _createElementVNode("label", {
            class: "flex items-center gap-1 text-sm font-medium text-slate-700"
          }, [_createElementVNode("svg", {
            class: "h-4 w-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
          })]), _createTextVNode(" 通知目标 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), notifyForm.scope === 2 ? (_openBlock(), _createBlock(DeptSelector, {
            key: 0,
            modelValue: notifyForm.scopeDeptList,
            "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => notifyForm.scopeDeptList = $event),
            placeholder: "请选择部门"
          }, null, 8, ["modelValue"])) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => notifyForm.scopeTargetInput = $event),
            class: "form-input",
            placeholder: "输入角色ID，逗号分隔"
          }, null, 512), [[_vModelText, notifyForm.scopeTargetInput]]), _cache[111] || (_cache[111] = _createElementVNode("p", {
            class: "mt-1.5 flex items-center gap-1 text-xs text-slate-500"
          }, [_createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          })]), _createTextVNode(" 多个ID用逗号分隔 ")], -1))], 64))])) : (_openBlock(), _createElementBlock("div", _hoisted_117, [...(_cache[113] || (_cache[113] = [_createElementVNode("div", {
            class: "flex items-center gap-2 text-sm text-primary-700"
          }, [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          })]), _createTextVNode(" 将向所有用户发送此通知 ")], -1)]))]))]), _createElementVNode("div", _hoisted_118, [_createElementVNode("button", {
            onClick: _cache[30] || (_cache[30] = $event => showNotifyModal.value = false),
            class: "cursor-pointer rounded-lg border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-600 transition-all hover:bg-slate-50 hover:text-slate-900"
          }, "取消"), _createElementVNode("button", {
            onClick: submitNotify,
            class: "cursor-pointer rounded-lg bg-primary-500 px-5 py-2 text-sm font-medium text-white shadow-sm shadow-primary-600/30 transition-all hover:bg-primary-700 hover:shadow-md hover:shadow-primary-600/40"
          }, [...(_cache[114] || (_cache[114] = [_createElementVNode("span", {
            class: "flex items-center gap-1.5"
          }, [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
          })]), _createTextVNode(" 发送通知 ")], -1)]))])])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showChainModal.value,
          size: "lg",
          "panel-class": "ring-1 ring-black/5",
          onClose: _cache[33] || (_cache[33] = $event => showChainModal.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_119, [_cache[117] || (_cache[117] = _createElementVNode("div", {
            class: "absolute inset-0 bg-grid-white/10"
          }, null, -1)), _createElementVNode("div", _hoisted_120, [_cache[116] || (_cache[116] = _createElementVNode("div", null, [_createElementVNode("h3", {
            class: "text-lg font-semibold text-white"
          }, "替代链"), _createElementVNode("p", {
            class: "mt-0.5 text-sm text-primary-100"
          }, "查看政策法规的替代演进关系")], -1)), _createElementVNode("button", {
            onClick: _cache[32] || (_cache[32] = $event => showChainModal.value = false),
            class: "rounded-full p-1.5 text-white/80 transition-colors hover:bg-white/20 hover:text-white"
          }, [...(_cache[115] || (_cache[115] = [_createElementVNode("svg", {
            class: "h-5 w-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])])]), _createElementVNode("div", _hoisted_121, [chainLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_122, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, n => {
            return _createElementVNode("div", {
              key: n,
              class: "h-16 rounded-xl bg-slate-100"
            });
          }), 64))])) : chainList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_123, [_cache[119] || (_cache[119] = _createElementVNode("div", {
            class: "absolute left-5 top-8 bottom-8 w-0.5 bg-gradient-to-b from-primary-200 via-primary-300 to-primary-200"
          }, null, -1)), _createElementVNode("div", _hoisted_124, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chainList.value, (item, idx) => {
            return _openBlock(), _createElementBlock("div", {
              key: item.id,
              class: _normalizeClass(["relative flex items-start gap-4 rounded-xl border p-4 transition-all", item.id === chainTarget.value?.id ? 'border-primary-200 bg-primary-50/50' : 'border-slate-200 bg-white hover:bg-slate-50'])
            }, [_createElementVNode("div", {
              class: _normalizeClass(["relative z-10 flex h-10 w-10 shrink-0 items-center justify-center rounded-full", item.id === chainTarget.value?.id ? 'bg-primary-600 text-white shadow-lg shadow-primary-600/30' : 'bg-slate-100 text-slate-500'])
            }, [_createElementVNode("span", _hoisted_125, _toDisplayString(idx + 1), 1)], 2), _createElementVNode("div", _hoisted_126, [_createElementVNode("div", _hoisted_127, [_createElementVNode("span", {
              class: _normalizeClass(["text-sm font-medium truncate", item.id === chainTarget.value?.id ? 'text-primary-700' : 'text-slate-900'])
            }, _toDisplayString(item.title), 3), item.id === chainTarget.value?.id ? (_openBlock(), _createElementBlock("span", _hoisted_128, "当前")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_129, [_createElementVNode("span", null, _toDisplayString(item.docNumber || '-'), 1), _cache[118] || (_cache[118] = _createElementVNode("span", {
              class: "text-slate-300"
            }, "•", -1)), _createElementVNode("span", {
              class: _normalizeClass(policyStatusClass(item.status))
            }, _toDisplayString(policyStatusText(item.status)), 3)])])], 2);
          }), 128))])])) : (_openBlock(), _createElementBlock("div", _hoisted_130, [...(_cache[120] || (_cache[120] = [_createElementVNode("div", {
            class: "empty-state-icon"
          }, [_createElementVNode("svg", {
            class: "h-8 w-8 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
          })])], -1), _createElementVNode("p", {
            class: "text-sm text-slate-500"
          }, "该法规暂无替代关系", -1)]))]))])]),
          _: 1
        }, 8, ["visible"]), showVersionDrawer.value ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_131, [_createElementVNode("div", {
          class: "absolute inset-0 bg-black/60 backdrop-blur-sm",
          onClick: _cache[34] || (_cache[34] = $event => showVersionDrawer.value = false)
        }), _createElementVNode("div", _hoisted_132, [_createElementVNode("div", _hoisted_133, [_createElementVNode("div", _hoisted_134, [_cache[123] || (_cache[123] = _createElementVNode("div", {
          class: "absolute inset-0 bg-grid-white/10"
        }, null, -1)), _createElementVNode("div", _hoisted_135, [_createElementVNode("div", null, [_cache[121] || (_cache[121] = _createElementVNode("h3", {
          class: "text-lg font-semibold text-white"
        }, "版本历史", -1)), _createElementVNode("p", _hoisted_136, _toDisplayString(versionTarget.value?.title), 1)]), _createElementVNode("button", {
          onClick: _cache[35] || (_cache[35] = $event => showVersionDrawer.value = false),
          class: "rounded-full p-1.5 text-white/80 transition-colors hover:bg-white/20 hover:text-white"
        }, [...(_cache[122] || (_cache[122] = [_createElementVNode("svg", {
          class: "h-5 w-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])])]), _createElementVNode("div", _hoisted_137, [versionLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_138, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, n => {
          return _createElementVNode("div", {
            key: n,
            class: "rounded-xl border border-slate-200 p-5"
          }, [...(_cache[124] || (_cache[124] = [_createElementVNode("div", {
            class: "h-5 w-16 rounded-full bg-slate-200"
          }, null, -1), _createElementVNode("div", {
            class: "mt-3 h-4 w-3/4 rounded bg-slate-200"
          }, null, -1), _createElementVNode("div", {
            class: "mt-2 h-3 w-1/2 rounded bg-slate-200"
          }, null, -1)]))]);
        }), 64))])) : versionList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_139, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(versionList.value, version => {
          return _openBlock(), _createElementBlock("div", {
            key: version.id,
            class: _normalizeClass(["group rounded-xl border p-5 transition-all", version.versionNo === versionTarget.value?.currentVersion ? 'border-violet-200 bg-primary-50/50' : 'border-slate-200 bg-white hover:border-slate-300 hover:shadow-sm'])
          }, [_createElementVNode("div", _hoisted_140, [_createElementVNode("div", _hoisted_141, [_createElementVNode("span", _hoisted_142, "v" + _toDisplayString(version.versionNo), 1), version.versionNo === versionTarget.value?.currentVersion ? (_openBlock(), _createElementBlock("span", _hoisted_143, "当前版本")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_144, [_createElementVNode("button", {
            onClick: $event => viewVersionDetail(version),
            class: "cursor-pointer rounded-lg px-2.5 py-1 text-xs font-medium text-slate-600 transition-colors hover:bg-slate-100"
          }, "查看", 8, _hoisted_145), version.versionNo !== versionTarget.value?.currentVersion ? _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: $event => handleRollback(version),
            class: "cursor-pointer rounded-lg px-2.5 py-1 text-xs font-medium text-primary-600 transition-colors hover:bg-primary-50"
          }, [...(_cache[125] || (_cache[125] = [_createTextVNode("回滚", -1)]))], 8, _hoisted_146)), [[_directive_permission, 'kb:policy:edit']]) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_147, _toDisplayString(version.title), 1), version.docNumber ? (_openBlock(), _createElementBlock("div", _hoisted_148, "文号：" + _toDisplayString(version.docNumber), 1)) : _createCommentVNode("", true), version.changeSummary ? (_openBlock(), _createElementBlock("div", _hoisted_149, [_cache[126] || (_cache[126] = _createElementVNode("span", {
            class: "font-medium text-slate-500"
          }, "修订说明：", -1)), _createTextVNode(_toDisplayString(version.changeSummary), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_150, [_createElementVNode("span", _hoisted_151, [_cache[127] || (_cache[127] = _createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          })], -1)), _createTextVNode(" " + _toDisplayString(_unref(formatDateTimeText)(version.createTime)), 1)]), _createElementVNode("span", _hoisted_152, [_cache[128] || (_cache[128] = _createElementVNode("svg", {
            class: "h-3.5 w-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
          })], -1)), _createTextVNode(" " + _toDisplayString(version.createBy || '系统'), 1)])])], 2);
        }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_153, [...(_cache[129] || (_cache[129] = [_createElementVNode("div", {
          class: "empty-state-icon"
        }, [_createElementVNode("svg", {
          class: "h-8 w-8 text-slate-400",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
        })])], -1), _createElementVNode("p", {
          class: "empty-state-title"
        }, "暂无版本记录", -1), _createElementVNode("p", {
          class: "empty-state-desc"
        }, "法规编辑后会自动生成版本历史", -1)]))]))])])])])), [[_directive_modal_a11y, () => showVersionDrawer.value = false]]) : _createCommentVNode("", true), _createVNode(AppModal, {
          visible: showConfirmModal.value,
          size: "md",
          "panel-class": "ring-1 ring-black/5",
          onClose: _cache[38] || (_cache[38] = $event => showConfirmModal.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_154, [_cache[132] || (_cache[132] = _createElementVNode("div", {
            class: "absolute inset-0 bg-grid-white/10"
          }, null, -1)), _createElementVNode("div", _hoisted_155, [_cache[131] || (_cache[131] = _createElementVNode("div", {
            class: "flex items-center gap-3"
          }, [_createElementVNode("div", {
            class: "flex h-10 w-10 items-center justify-center rounded-full bg-white/20"
          }, [_createElementVNode("svg", {
            class: "h-5 w-5 text-white",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          })])]), _createElementVNode("div", null, [_createElementVNode("h3", {
            class: "text-lg font-semibold text-white"
          }, "确认删除"), _createElementVNode("p", {
            class: "mt-0.5 text-sm text-red-100"
          }, "此操作不可撤销")])], -1)), _createElementVNode("button", {
            onClick: _cache[36] || (_cache[36] = $event => showConfirmModal.value = false),
            class: "rounded-full p-1.5 text-white/80 transition-colors hover:bg-white/20 hover:text-white"
          }, [...(_cache[130] || (_cache[130] = [_createElementVNode("svg", {
            class: "h-5 w-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])])]), _createElementVNode("div", _hoisted_156, [_createElementVNode("div", _hoisted_157, _toDisplayString(confirmMessage.value), 1)]), _createElementVNode("div", _hoisted_158, [_createElementVNode("button", {
            onClick: _cache[37] || (_cache[37] = $event => showConfirmModal.value = false),
            class: "cursor-pointer rounded-lg border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-600 transition-all hover:bg-slate-50 hover:text-slate-900"
          }, "取消"), _createElementVNode("button", {
            onClick: confirmDeleteAction,
            class: "cursor-pointer rounded-lg bg-red-600 px-5 py-2 text-sm font-medium text-white shadow-sm shadow-red-600/30 transition-all hover:bg-red-700 hover:shadow-md hover:shadow-red-600/40"
          }, [...(_cache[133] || (_cache[133] = [_createElementVNode("span", {
            class: "flex items-center gap-1.5"
          }, [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          })]), _createTextVNode(" 确认删除 ")], -1)]))])])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showPreviewModal.value,
          size: "5xl",
          "panel-class": "h-[90vh] ring-1 ring-black/5",
          "z-index": 70,
          scrollable: false,
          onClose: closePreviewModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_159, [_cache[136] || (_cache[136] = _createElementVNode("div", {
            class: "absolute inset-0 bg-grid-white/10"
          }, null, -1)), _createElementVNode("div", _hoisted_160, [_cache[134] || (_cache[134] = _createElementVNode("div", {
            class: "relative flex h-8 w-8 items-center justify-center rounded-lg bg-white/10 text-white"
          }, [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          })])], -1)), _createElementVNode("h3", _hoisted_161, _toDisplayString(previewFileName.value), 1)]), _createElementVNode("button", {
            onClick: closePreviewModal,
            class: "relative cursor-pointer rounded-full p-1.5 text-white/80 transition-colors hover:bg-white/20 hover:text-white"
          }, [...(_cache[135] || (_cache[135] = [_createElementVNode("svg", {
            class: "h-5 w-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_162, [previewUrl.value ? (_openBlock(), _createElementBlock("iframe", {
            key: 0,
            src: previewUrl.value,
            class: "h-full w-full border-0",
            frameborder: "0"
          }, null, 8, _hoisted_163)) : _createCommentVNode("", true)])]),
          _: 1
        }, 8, ["visible"]), (_openBlock(), _createBlock(_Teleport, {
          to: "body"
        }, [openMoreId.value !== null ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed z-[9999] w-44 overflow-hidden rounded-xl border border-slate-200 bg-white py-1.5 shadow-xl ring-1 ring-black/5",
          style: _normalizeStyle(moreMenuStyle.value),
          onClick: _cache[44] || (_cache[44] = _withModifiers(() => {}, ["stop"]))
        }, [openMoreItem.value?.status === 0 ? _withDirectives((_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[39] || (_cache[39] = $event => handlePublish(openMoreItem.value)),
          class: "flex w-full cursor-pointer items-center gap-2.5 px-4 py-2 text-left text-sm text-slate-700 transition-colors hover:bg-emerald-50 hover:text-emerald-700"
        }, [...(_cache[137] || (_cache[137] = [_createElementVNode("svg", {
          class: "h-4 w-4 text-emerald-500",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
        })], -1), _createTextVNode(" 发布 ", -1)]))])), [[_directive_permission, 'kb:policy:edit']]) : _createCommentVNode("", true), openMoreItem.value?.status === 1 ? _withDirectives((_openBlock(), _createElementBlock("button", {
          key: 1,
          onClick: _cache[40] || (_cache[40] = $event => handleInvalidate(openMoreItem.value)),
          class: "flex w-full cursor-pointer items-center gap-2.5 px-4 py-2 text-left text-sm text-slate-700 transition-colors hover:bg-primary-50 hover:text-primary-700"
        }, [...(_cache[138] || (_cache[138] = [_createElementVNode("svg", {
          class: "h-4 w-4 text-amber-500",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
        })], -1), _createTextVNode(" 标记失效 ", -1)]))])), [[_directive_permission, 'kb:policy:edit']]) : _createCommentVNode("", true), openMoreItem.value?.status === 1 ? _withDirectives((_openBlock(), _createElementBlock("button", {
          key: 2,
          onClick: _cache[41] || (_cache[41] = $event => openNotifyModal(openMoreItem.value)),
          class: "flex w-full cursor-pointer items-center gap-2.5 px-4 py-2 text-left text-sm text-slate-700 transition-colors hover:bg-blue-50 hover:text-blue-700"
        }, [...(_cache[139] || (_cache[139] = [_createElementVNode("svg", {
          class: "h-4 w-4 text-blue-500",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
        })], -1), _createTextVNode(" 发送通知 ", -1)]))])), [[_directive_permission, 'kb:policy:edit']]) : _createCommentVNode("", true), _createElementVNode("button", {
          onClick: _cache[42] || (_cache[42] = $event => openSupersedChain(openMoreItem.value)),
          class: "flex w-full cursor-pointer items-center gap-2.5 px-4 py-2 text-left text-sm text-slate-700 transition-colors hover:bg-indigo-50 hover:text-primary-700"
        }, [...(_cache[140] || (_cache[140] = [_createElementVNode("svg", {
          class: "h-4 w-4 text-indigo-500",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
        })], -1), _createTextVNode(" 替代链 ", -1)]))]), _cache[142] || (_cache[142] = _createElementVNode("div", {
          class: "my-1.5 border-t border-slate-100"
        }, null, -1)), _withDirectives((_openBlock(), _createElementBlock("button", {
          onClick: _cache[43] || (_cache[43] = $event => confirmDeleteItem(openMoreItem.value)),
          class: "flex w-full cursor-pointer items-center gap-2.5 px-4 py-2 text-left text-sm text-red-600 transition-colors hover:bg-red-50"
        }, [...(_cache[141] || (_cache[141] = [_createElementVNode("svg", {
          class: "h-4 w-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
        })], -1), _createTextVNode(" 删除 ", -1)]))])), [[_directive_permission, 'kb:policy:edit']])], 4)) : _createCommentVNode("", true)])), _createVNode(KbDetailPreviewModal, {
          modelValue: showMpPreviewModal.value,
          "onUpdate:modelValue": _cache[45] || (_cache[45] = $event => showMpPreviewModal.value = $event),
          type: "policy",
          "item-id": previewItemId.value,
          "preview-data": previewPolicyData.value
        }, null, 8, ["modelValue", "item-id", "preview-data"])]),
        _: 1
      });
    };
  }
};